import React, { memo } from "react";
import { ImageStyled } from "./style";

const Image = ({ src, alt, ...props }) => {
  return <ImageStyled src={src} alt={alt} loading="lazy" {...props} />;
};

export default memo(Image);
